export { Tag } from './Tag'
export type { TagProps } from './Tag'
